module.exports = __webpack_public_path__ + "img/BentonSansBBVA-Medium.a4c3b927.svg";